<div id="try-silq-free" class="try_free_silq_main" fxLayout="column">
  <div id="try-silq-free-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="try-silq-free-form"
      [@animate]="{
        value: '*',
        params: { duration: '300ms', y: '100px' },
      }"
    >
      <div class="logo">
        <img src="assets/images/logos/75.png" />
      </div>
      <div class="title mt-6">Try SILQ Free</div>
      @if (isTry) {
        <form name="trySilqFreeForm" [formGroup]="trySilqFreeForm" novalidate>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" readonly />
          </mat-form-field>
          <mat-form-field appearance="outline" class="mt-8">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" readonly />
          </mat-form-field>
          <mat-form-field appearance="outline" class="mt-8">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone" readonly />
          </mat-form-field>
          @if (isCreateDb) {
            <div class="async-info-text">
              Do you want an empty data file or would you like example data so that you can explore
              SILQ better?
            </div>
          }
          <mat-form-field appearance="outline" class="mt-8">
            <mat-label>Initial Data</mat-label>
            <mat-select formControlName="initialData">
              <mat-option value="">Empty</mat-option>
              <mat-option value="LARGEDATATRIAL">Example Data</mat-option>
            </mat-select>
          </mat-form-field>
          <button
            matButton="filled"
            class="submit-button mat-primary mt-8 flex justify-center"
            *ngIf="!isDatabaseCreated"
            (click)="saveDataBase()"
            aria-label="Save"
            [disabled]="isspiner || trySilqFreeForm.invalid"
          >
            @if (isspiner) {
              <mat-spinner diameter="24"></mat-spinner>
            }
            Create database
          </button>
          <button
            mat-raised-button
            color="accent"
            class="submit-button register-button mat-primary mt-8 flex justify-center"
            *ngIf="isDatabaseCreated"
            (click)="redirectToLogin()"
            [disabled]="isspiner"
            aria-label="Save"
            [disabled]="trySilqFreeForm.invalid"
          >
            <mat-spinner *ngIf="isspiner"></mat-spinner>
            Login
          </button>
        </form>
      }
      @if (!isTry) {
        <form name="tryLoginForm" [formGroup]="tryLoginForm" novalidate>
          <mat-form-field appearance="outline">
            <mat-label>Username/Email</mat-label>
            <input matInput formControlName="username" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" />
            <mat-icon matSuffix (click)="hide = !hide">
              {{ hide ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </mat-form-field>
          <button
            matButton="filled"
            class="submit-button"
            (click)="loginUser()"
            [disabled]="isspiner"
            aria-label="Save"
            [disabled]="tryLoginForm.invalid"
          >
            @if (isspiner) {
              <mat-spinner diameter="24"></mat-spinner>
            }
            Login
          </button>
        </form>
      }
      @if (showEmailInfoText) {
        <div class="email-info-text">You have been emailed your login credentials.</div>
      }

      @if (isCreateDb) {
        <div class="title-footer">
          <mat-progress-bar
            style="height: 1em"
            mode="determinate"
            [value]="progress"
          ></mat-progress-bar>
          <br />
          <h2 class="mt-[40px]! text-[22px]! leading-[22px]!">{{ btnText }}</h2>
        </div>
      }
    </div>
  </div>
</div>
